import Axios from "@/plugins/Axios";

export class PlanosSemanais {
  async planoSemanal(gestaoDeAulaId, mes_id, semana_id, dia_semana_id, disciplinaId) {
    const response = await Axios().get(
      `planos-semanais/plano-mensal/${gestaoDeAulaId}/${mes_id}/${semana_id}/${dia_semana_id}/${disciplinaId}`
    );

    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-semanais/criar-plano-mensal`, {
      plano,
    });
    return response.data;
  }

  async planoSemanalPDF(gestaoDeAulaId, disciplina_id, mes_id, semana_id, dia_semana_id, file) {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await Axios().post(
        `planos-semanais/uploadPdf/${gestaoDeAulaId}/${disciplina_id}/${mes_id}/${semana_id}/${dia_semana_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const resultData = response.data ?? response;
      if (resultData) {
        return resultData;
      }
      return null;
    } catch (error) {
      throw error;
    }
  }

  async downloadPlanoSemanal(gestaoDeAulaId, disciplina_id, mes_id, semana_id, dia_semana_id) {
    const response = await Axios()
      .get(`planos-semanais/downloadPdf/${gestaoDeAulaId}/${disciplina_id}/${mes_id}/${semana_id}/${dia_semana_id}`, {
        responseType: "blob",
      })
      .then((response) => {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(response.data);
        window.open(a.href);
      });

    return response;
  }
}

export default new PlanosSemanais();
